module.exports = __webpack_public_path__ + "static/media/gitlab_small_logo.97cbbc1f.png";